import React, { useState } from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import AddSubCategory from './addBlogSubCategoryForm';
import classes from '../../WebsiteManagement/websiteManagement.module.css';

const AddBlogSubCategory = (props)=>{
    const [active,updateActive] = useState("1");
    return(
        <Container fluid className={classes.Box}>
            <Row style={{margin:'0 0 2% 0',textAlign:'center',cursor:'pointer'}}>
                <Col xs={12} className={classes.Col} 
                style={{backgroundColor:`${active==='1'?'steelblue':'#585858'}`,color:'white',padding:'1%'}}
                onClick={()=>updateActive("1")}>
                    Add Blog Sub Category
                </Col>
            </Row>
            {
                active==="1"?<AddSubCategory categoryType="SUB CATEGORY"/>:null
            }
        </Container>        
    )
}        
export default AddBlogSubCategory;